import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, Popconfirm, Select, Tag } from 'antd';

const { Option } = Select;

export default function ProductPropertyLibraryModal(props) {
    const {
        visible,
        onClose,
        properties = [],
        createPropertyName,
        onCreatePropertyNameChange,
        onCreateProperty,
        onUpdateProperty,
        onDeleteProperty
    } = props;
    const [drafts, setDrafts] = useState([]);

    useEffect(() => {
        if (!visible) return;
        setDrafts((properties || []).map((item) => ({
            _id: item._id,
            name: item.name || '',
            values: item.values || []
        })));
    }, [visible, properties]);

    const updateDraft = (propertyId, patch = {}) => {
        setDrafts((current) => current.map((item) => (
            `${item._id}` === `${propertyId}` ? { ...item, ...patch } : item
        )));
    };

    const handleSaveProperty = async (propertyId) => {
        const draft = drafts.find((item) => `${item._id}` === `${propertyId}`);
        if (!draft) return;
        const savedProperty = await onUpdateProperty(propertyId, { name: draft.name, values: draft.values });
        if (!savedProperty) return;
        updateDraft(propertyId, {
            name: savedProperty.name || '',
            values: savedProperty.values || []
        });
    };

    return (
        <Modal
            title="Quản lý thư viện thuộc tính"
            visible={visible}
            onCancel={onClose}
            footer={[
                <Button key="close" onClick={onClose}>Đóng</Button>
            ]}
            width={820}
        >
            <div style={{ color: '#6b7280', marginBottom: 16 }}>
                Thêm thuộc tính mới hoặc cập nhật tập giá trị để dùng trong tạo nhanh variant.
            </div>
            <table className="table table-sm" style={{ marginBottom: 0 }}>
                <thead>
                    <tr>
                        <th style={{ width: '35%' }}>Tên thuộc tính</th>
                        <th>Giá trị</th>
                        <th style={{ width: 220 }}>Thao tác</th>
                    </tr>
                </thead>
                <tbody>
                    {drafts.map((property) => (
                        <tr key={property._id || property.name}>
                            <td>
                                <Input
                                    value={property.name}
                                    onChange={(e) => updateDraft(property._id, { name: e.target.value })}
                                    onPressEnter={() => handleSaveProperty(property._id)}
                                    onBlur={() => handleSaveProperty(property._id)}
                                />
                            </td>
                            <td>
                                <Select
                                    mode="tags"
                                    style={{ width: '100%' }}
                                    placeholder="Nhập hoặc chọn nhiều giá trị"
                                    value={property.values || []}
                                    onChange={(values) => {
                                        updateDraft(property._id, { values });
                                        onUpdateProperty(property._id, { name: property.name, values });
                                    }}
                                >
                                    {(property.values || []).map((value) => <Option key={value} value={value}>{value}</Option>)}
                                </Select>
                            </td>
                            <td>
                                <div className="d-flex align-items-center justify-content-between" style={{ gap: 8 }}>
                                    <Tag color="blue">{property.values ? property.values.length : 0} giá trị</Tag>
                                    <Button size="small" onClick={() => handleSaveProperty(property._id)}>Lưu</Button>
                                    <Popconfirm
                                        title="Xóa thuộc tính này?"
                                        okText="Xóa"
                                        cancelText="Hủy"
                                        onConfirm={() => onDeleteProperty(property)}
                                    >
                                        <Button danger size="small">Xóa</Button>
                                    </Popconfirm>
                                </div>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td>
                            <Input
                                placeholder="Tên thuộc tính mới"
                                value={createPropertyName}
                                onChange={(e) => onCreatePropertyNameChange(e.target.value)}
                                onPressEnter={onCreateProperty}
                            />
                        </td>
                        <td style={{ color: '#9ca3af' }}>
                            Tạo thuộc tính trước, sau đó cập nhật giá trị ở dòng vừa thêm
                        </td>
                        <td>
                            <Button type="primary" onClick={onCreateProperty} disabled={!createPropertyName.trim()}>Tạo</Button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </Modal>
    );
}
